import $ from 'jquery';
import dt from 'datatables.net';
import LazyLoad from 'vanilla-lazyload';
import Swiper from 'swiper';

$.fn.DataTable = dt;

window.$ = window.jQuery = $;

window.Swiper = Swiper;

require('bootstrap-sass');
window.videojs = require('video.js');
require('videojs-youtube');
require('waypoints/lib/jquery.waypoints');
require('waypoints/lib/shortcuts/infinite');
require('waypoints/lib/shortcuts/sticky');
require('select2');
require('@fancyapps/fancybox');
require('jquery-countdown');
window.StickySidebar = require('sticky-sidebar');
require('sticky-kit/dist/sticky-kit');
require('iframe-resizer');
require('./infiniteScroll');
require('./articleInfiniteScroll');
require('./Header');
require('./Search');
require('./slideMenu');
require('./arkansasSchedule');
require('./PhotoGallery');
require('./MoreMenu');
require('./InfiniteGloryPosts');
require('./BossButton');
require('./Gallery');
require('./ComingUpBlock');
require('./MasterSchedules');
require('./share');
require('./VideoArchive');
require('./SearchFacility');
require('./News');
require('./Gallery');
require('./szn');
require('./19for19');
require('./neutralized');
require('./StaffDirectoryFilters');

window.isMobile = function() {
  var check = false;
  (function(a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4))) {
      check = true;
    }
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

window.firePageView = function(url) {
  if (!url) {
    url = window.location.href;
  }

  let urls = [
    '/sports/football/schedule/',
    '/sports/football/roster/',
    '/sports/baseball/schedule/',
    '/sports/baseball/roster/',
  ];

  if (url.startsWith('/wp-json/')) {
    url = urls[Math.floor(Math.random() * urls.length)];
  }

  try {
    url = url.replace(window.location.origin, '');

    if (typeof ga === 'function') {
      setTimeout(function() {
        ga('set', 'page', url);
        ga('send', 'pageview');

        ga('newTracker.set', 'page', url);
        ga('newTracker.send', 'pageview');
      }, 5000);
    }
  } catch (e) {

  }
};

$(document).ready(function() {
  new Search({
    container: '#bordeaux-top-menu',
    searchingClass: 'searching',
    searchLink: '.search-link',
    inputClass: '.search-input',
    closeButton: '.close-button',
  });

  new Header({});

  new SlideMenu({});
  new BossButton();
  new Sharer();

  $.fn.select2.defaults.set('theme', 'arkansas');

  if ($('[data-init="select2"]').length) {
    $('[data-init="select2"]').select2({
      width: null,
    });
  }

  new PhotoGallery();

  $('[data-init="datatable"]').DataTable({
    'paging': false,
    'info': false,
    'autoWidth': false,
    'searching': false,
    'aaSorting': [],
  });

  $('[data-init="datatable_roster"]').DataTable({
    'paging': false,
    'info': false,
    'autoWidth': false,
    'searching': false,
    'aaSorting': [],
    'order': [[0, 'asc']],
  });

  new MoreMenu();

  new Szn({});

  new Event19for19({});

  new Neutralized({});

  $('.filters__sports > a').click(function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('opened');
  });

  var sidebarLeft = $('.sidebar');
  if (sidebarLeft.length) {
    sidebarLeft.after('<div class="sticky-content-spacer"/>');
    sidebarLeft.stick_in_parent({
      offset_top: 75,
      inner_scrolling: true,
      parent: '.sticky-parent-wrapper',
      spacer: '.sticky-content-spacer',
    });
  }

  $('.bordeaux-content').waypoint({
    handler: function(direction) {
      if (direction === 'up') {
        $(window).trigger('resize');
      }
    },
    offset: -150,
  });

  // Change View in Master Schedules page
  var $changeSchedulesViewSelector = $('.schedule-page .title .view'),
    $changeListSchedulesViewLink = $changeSchedulesViewSelector.find(
      'a.list-view'),
    $changeCalendarSchedulesViewLink = $changeSchedulesViewSelector.find(
      'a.calendar-view_btn');
  if ($changeSchedulesViewSelector.length) {
    $changeListSchedulesViewLink.click(function(e) {
      e.preventDefault();
      $changeListSchedulesViewLink.removeClass('active');
      $changeCalendarSchedulesViewLink.addClass('active');
      $('.calendar-view').hide();
      $('.list_view').show();
    });
    $changeCalendarSchedulesViewLink.click(function(e) {
      e.preventDefault();
      $changeCalendarSchedulesViewLink.removeClass('active');
      $changeListSchedulesViewLink.addClass('active');
      $('.list_view').hide();
      $('.calendar-view').show();
    });
  }

  var $tableSelector = $('table.tablepress'),
    $contentTable = $('.content table');
  if ($tableSelector.length) {
    $tableSelector.wrap('<div class="table_wrap"></div>');
  }
  if ($contentTable.length) {
    $contentTable.wrap('<div class="table_wrap"></div>');
  }

  var hash = window.location.hash;
  hash && $('ul.nav a[href="' + hash + '"]').tab('show');

  // Enable iframe autoresize
  var iframeElement = $('iframe.resize');

  if (iframeElement.length) {
    window.iFrameResize({autoResize: true}, iframeElement);
  }

  $('.nav-tabs a').click(function(e) {
    $(this).tab('show');
    var scrollmem = $('body').scrollTop();
    window.location.hash = this.hash;
    $('html, body').scrollTop(scrollmem);

    var tabId = $(event.target).attr('href'),
      $currentTab = $(tabId),
      $iframes = $currentTab.find('iframe');
    if ($iframes.length) {
      $.each($iframes, function(k, v) {
        window.iFrameResize({autoResize: true}, $(v));
      });
    }
  });

  var $shareSelector = $('.article-share');
  if ($shareSelector.length) {
    $shareSelector.stick_in_parent({
      offset_top: 110,
      sticky_class: 'is_stuck',
      recalc_every: 1,
      parent: '.article_wrapper',
    });
  }

  var $parallaxVideoSelector = $('.parallax-video');
  if ($parallaxVideoSelector.length) {
    $parallaxVideoSelector.find('.sound_control').click(function(e) {
      e.preventDefault();
      if ($parallaxVideoSelector.find('.sound_control').hasClass('muted')) {
        $parallaxVideoSelector.find('.sound_control').removeClass('muted');
        $parallaxVideoSelector.find('video').prop('muted', false);
      } else {
        $parallaxVideoSelector.find('.sound_control').addClass('muted');
        $parallaxVideoSelector.find('video').prop('muted', true);
      }
    });
  }

  var $submitForm = $('.submit_portal .form');

  if ($submitForm.length) {
    $('.wpforms-field.wpforms-field-divider, .wpforms-field.wpforms-field-textarea, .wpforms-field.wpforms-field-text, .wpforms-field.wpforms-field-email').
      wrapAll('<div class="box"></div>');
  }

  let $article_photo_slider = '.gallery_slider';
  if ($($article_photo_slider).length) {
    new window.Swiper($article_photo_slider + ' .swiper-container', {
      slidesPerView: 3,
      loop: true,
      observeParents: true,
      spaceBetween: 2,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        767: {
          slidesPerView: 3,
        },
      },
    });
  }

  let $faqListSelector = document.querySelectorAll('.faq-list');
  if ($faqListSelector.length) {
    $faqListSelector.forEach(block => {
      let $faqItemLink = block.querySelectorAll('.faq-list__item');

      $faqItemLink.forEach(link => {
        link.querySelector('.open').addEventListener('click', function(e) {
          e.preventDefault();

          e.target.classList.toggle('opened');
          e.target.parentNode.classList.toggle('opened');
        });
      });
    });
  }

  const $tickets_slider = '.tickets-list';
  if ($($tickets_slider).length) {
    new window.Swiper($tickets_slider + ' .swiper-container', {
      slidesPerView: 1,
      loop: true,
      observeParents: true,
      spaceBetween: 10
    });
  }
});

const lazyLoadInstance = new LazyLoad({});

const updateLazyLoadObserver = new MutationObserver(() => {
  lazyLoadInstance && lazyLoadInstance.update();
});

updateLazyLoadObserver.observe(document, {subtree: true, childList: true});
